import React, { useState, useEffect } from "react";

import Loading from "./../components/Loading";
import { getForms } from "../utils/backend";
import FormsList from "../components/FormsList";

const Home = () => {
  const [loading, setLoading] = useState(false);
  const [forms, setForms] = useState([]);

  useEffect(() => {
    const fetchForms = async () => {
      setLoading(true);
      const forms = await getForms();
      setLoading(false);

      setForms(forms);
    };

    fetchForms();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <h3 className="mb-4">Your Forms</h3>
      <FormsList forms={forms} />
    </div>
  );
};

export default Home;
